import { scrollToSection, SECTION_IDS } from '@/lib/index';

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer
      className="relative pt-20 pb-10 overflow-hidden"
      style={{
        background: 'linear-gradient(to top, #000008 0%, rgba(10,10,20,0) 100%)',
        borderTop: '1px solid rgba(255,255,255,0.05)',
      }}
    >
      {/* Glow */}
      <div
        className="absolute bottom-0 left-1/2 -translate-x-1/2 w-96 h-32 opacity-20 pointer-events-none"
        style={{
          background: 'radial-gradient(ellipse, #7C3AED 0%, transparent 70%)',
          filter: 'blur(40px)',
        }}
      />

      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16">
          {/* Brand */}
          <div className="md:col-span-2">
            <button
              onClick={() => scrollToSection(SECTION_IDS.HERO)}
              className="flex items-center gap-3 mb-4 cursor-pointer"
            >
              <div className="w-10 h-10">
                <img
                  src="/images/logo_kufuta.jpeg"
                  alt="KufutaPay+ Logo"
                  className="w-full h-full object-contain rounded-lg"
                  style={{
                    filter: 'brightness(1.1) contrast(1.1)',
                  }}
                />
              </div>
              <span className="text-xl font-bold text-white">
                KufutaPay<span style={{ background: 'linear-gradient(90deg, #06B6D4, #67e8f9)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>+</span>
              </span>
            </button>
            <p className="text-white/50 text-sm leading-relaxed max-w-xs font-light">
              A infraestrutura financeira para a economia informal de Angola. Transformamos comerciantes invisíveis em negócios empoderados.
            </p>
            <p className="text-white/30 text-xs mt-4 font-light">
              Luanda, Angola — construído para Africa
            </p>
          </div>

          {/* Links */}
          <div>
            <h4 className="text-white/80 text-sm font-semibold mb-4 tracking-wider uppercase">Plataforma</h4>
            <ul className="space-y-3">
              {[
                { label: 'Smart POS', section: SECTION_IDS.SOLUTION },
                { label: 'Crédito Comportamental', section: SECTION_IDS.SOLUTION },
                { label: 'Crédito de Stock', section: SECTION_IDS.SOLUTION },
                { label: 'PAGA FÁCIL', section: SECTION_IDS.SOLUTION },
              ].map((item) => (
                <li key={item.label}>
                  <button
                    onClick={() => scrollToSection(item.section)}
                    className="text-white/40 hover:text-white/80 text-sm transition-colors duration-200 cursor-pointer font-light"
                  >
                    {item.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-white/80 text-sm font-semibold mb-4 tracking-wider uppercase">Empresa</h4>
            <ul className="space-y-3">
              {[
                { label: 'O Problema', section: SECTION_IDS.PROBLEM },
                { label: 'Mercado', section: SECTION_IDS.MARKET },
                { label: 'Impacto ESG', section: SECTION_IDS.IMPACT },
                { label: 'Parceiros', section: SECTION_IDS.CTA },
              ].map((item) => (
                <li key={item.label}>
                  <button
                    onClick={() => scrollToSection(item.section)}
                    className="text-white/40 hover:text-white/80 text-sm transition-colors duration-200 cursor-pointer font-light"
                  >
                    {item.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div
          className="pt-8 flex flex-col md:flex-row items-center justify-between gap-4"
          style={{ borderTop: '1px solid rgba(255,255,255,0.05)' }}
        >
          <p className="text-white/25 text-xs font-light">
            &copy; {year} KufutaPay+. Todos os direitos reservados.
          </p>
          <div className="flex items-center gap-6">
            <span className="text-white/25 text-xs font-light">Política de Privacidade</span>
            <span className="text-white/25 text-xs font-light">Termos de Serviço</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
